module.exports = __webpack_public_path__ + "img/research_iton_5.16a9c491.png";